import styled from 'styled-components';
import { Alert } from '@amzn/storm-ui';

export const PageBannerContainer = styled.div<{
  isFocusLayout: boolean;
}>`
  ${({ theme, isFocusLayout }) =>
    isFocusLayout
      ? `padding: ${theme.spacing.xsmall.default} ${theme.spacing.base.default};`
      : `padding: ${theme.spacing.xsmall.default} ${theme.spacing.base.default} 0;
       margin-bottom: ${theme.spacing.xsmall.default};`}
`;

export const TruncatedTextWrapper = styled.div`
  display: grid;
  grid-template-columns: auto min-content;
  max-width: 1200px;
  margin: 0 auto;
  justify-content: center;
`;

export const TruncatedText = styled.div`
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const BannerText = styled.span`
  display: inline;
`;

export const StyledAlert = styled(Alert)`
  max-width: 100%;
`;
